import DialogContent, {
  type DialogContentProps
} from '@mui/material/DialogContent';
import { forwardRef, type PropsWithChildren } from 'react';

const Content = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DialogContentProps>
>(({ children, ...props }, ref) => (
  <DialogContent dividers ref={ref} {...props}>
    {children}
  </DialogContent>
));

Content.displayName = 'Content';

export default Content;
